module.exports = __webpack_public_path__ + "assets/img/cheops_logo.svg";